import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUsers, FaComments, FaHome } from "react-icons/fa";
import "../style-new.css";

const ChatLanding = ({ currentUser, loadingUser }) => {
  const navigate = useNavigate();
  const [groupUnread, setGroupUnread] = useState(0);
  const [directUnread, setDirectUnread] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchUnreadCounts = async () => {
      try {
        const res = await fetch("/api/chat/unread-count", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        setGroupUnread(data.groupUnread);
        setDirectUnread(data.directUnread);
      } catch (err) {
        console.error("Error fetching unread counts:", err);
      }
    };

    fetchUnreadCounts();
  }, [navigate]);

  if (loadingUser || !currentUser || !currentUser.id) {
    return <div className="center-content">Loading chat...</div>;
  }

  return (
    <div className="page-container">
      <div className="center-content">
        <h2>Welcome to Teamo Chat</h2>
        <p>Select a chat type to get started:</p>

        <div className="button-group" style={{ marginTop: "30px" }}>
          <button className="btn btn-primary" onClick={() => navigate("/")}>
            <FaHome />
            Home
          </button>

<div className="btn-wrapper">
  <button
    className="btn btn-primary"
    onClick={() => navigate("/chat/groups")}
  >
    <FaUsers />
    Group Chats
    {groupUnread > 0 && (
      <span className="chat-badge">{groupUnread}</span>
    )}
  </button>
</div>

<div className="btn-wrapper">
  <button
    className="btn btn-primary"
    onClick={() => navigate("/chat/direct")}
  >
    <FaComments />
    Direct Messages
    {directUnread > 0 && (
      <span className="chat-badge">{directUnread}</span>
    )}
  </button>
</div>

        </div>
      </div>
    </div>
  );
};

export default ChatLanding;
